import { Controller } from "@hotwired/stimulus"

// This is useful when we can't use a form because the anchor is already inside a form.
export default class extends Controller {
  static targets = ["anchor"]
  static values = { path: String }

  update({ target }) {
    if (target.value === "") {
      this.anchorTarget.removeAttribute("href")

      return
    }

    const url = new URL(this.pathValue, window.location)
    url.searchParams.set(target.name, target.value)
    this.anchorTarget.setAttribute("href", url.toString())
  }

  submit(event) {
    event.preventDefault()
    this.anchorTarget.click()
  }
}
